import { useContext, useEffect, useReducer, useState } from "react";
import { Store } from "../Store";
import { getError } from "../utils";
import useAxios from "./useAxios";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default function useProductsAndCategories() {
  const axios = useAxios();
  const { dispatch: ctxDispatch, state } = useContext(Store);
  const { userInfo, products, categories, leafCategories } = state;
  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const [loadProducts, setLoadProducts] = useState(false);
  const [loadCategories, setLoadCategories] = useState(false);
  const [loadLeafCategories, setLoadLeafCategories] = useState(false);

  const fetchProducts = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST", payload: {} });
      const { data } = await axios.get(`/api/products`);

      const { data: data2 } = await axios.get(
        `/api/products/mostUsedFromDaily`
      );

      data.forEach((p) => {
        if (
          !data2.some((p2) => {
            if (p2._id === p._id) {
              return true;
            } else {
              return false;
            }
          })
        ) {
          data2.push(p);
        }
      });

      dispatch({ type: "FETCH_SUCCESS" });
      ctxDispatch({
        type: "PRODUCTS_UPDATED",
        payload: { products: data || [], mostUsedProducts: data2 || [] },
      });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  const fetchCategories = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST", payload: {} });
      const { data } = await axios.get(
        `/api/categories/withProductsAndSubCategories`
      );

      dispatch({ type: "FETCH_SUCCESS" });
      ctxDispatch({
        type: "CATEGORIES_UPDATED",
        payload: data || { categories: [], allCategories: [] },
      });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  const fetchLeafCategories = async () => {
    try {
      const { data } = await axios.get(`/api/categories/leafes/compartment`);
      ctxDispatch({
        type: "LEAF_CATEGORIES_UPDATED",
        payload: data || [],
      });
    } catch (err) {}
  };

  useEffect(() => {
    if (
      userInfo &&
      (!userInfo.isHelpDesk || (userInfo.isHelpDesk && userInfo.client)) &&
      !products
    ) {
      fetchProducts();
    }
  }, [userInfo]);

  useEffect(() => {
    if (
      userInfo &&
      (!userInfo.isHelpDesk || (userInfo.isHelpDesk && userInfo.client)) &&
      !categories
    ) {
      fetchCategories();
    }
  }, [userInfo]);

  useEffect(() => {
    if (
      userInfo &&
      (!userInfo.isHelpDesk || (userInfo.isHelpDesk && userInfo.client)) &&
      !leafCategories
    ) {
      fetchLeafCategories();
    }
  }, [userInfo]);

  useEffect(() => {
    if (
      userInfo &&
      (!userInfo.isHelpDesk || (userInfo.isHelpDesk && userInfo.client)) &&
      loadProducts
    ) {
      fetchProducts();
      setLoadProducts(false);
    }
  }, [loadProducts, userInfo]);

  useEffect(() => {
    if (
      userInfo &&
      (!userInfo.isHelpDesk || (userInfo.isHelpDesk && userInfo.client)) &&
      loadCategories
    ) {
      fetchCategories();
      setLoadCategories(false);
    }
  }, [loadCategories, userInfo]);

  useEffect(() => {
    if (
      userInfo &&
      (!userInfo.isHelpDesk || (userInfo.isHelpDesk && userInfo.client)) &&
      loadLeafCategories
    ) {
      fetchLeafCategories();
      setLoadLeafCategories(false);
    }
  }, [loadLeafCategories, userInfo]);

  return [
    loading,
    error,
    setLoadProducts,
    setLoadCategories,
    setLoadLeafCategories,
  ];
}
